var _line, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPolicyCurve(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 78,
    viewBox: "0 0 11 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1.5,
    y1: 2.18557e-8,
    x2: 1.5,
    y2: 78,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 0V47C1 52.5228 5.47715 57 11 57V57",
    stroke: "#0052CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 14V19.5C1 25.0228 5.47715 29.5 11 29.5V29.5",
    stroke: "#0052CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolicyCurve);
export default __webpack_public_path__ + "static/media/Policy-curve.7014dfde8ad3122f578b05f06a3a1938.svg";
export { ForwardRef as ReactComponent };